import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ConfirmUserPage from "./Components/Login/ConfirmUser";
import Accounts from "./Components/Accounts/Accounts";
import Activity from "./Components/Activity/Activity";
import Navbar from "./Components/Navbar/Navbar";
import LoginPage from "./Components/Login/login";
import AddAccounts from "./Components/AddAccounts/AddAccounts";
import "./App.css";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { setAdmin, clearAdmin } from "./Service/Reducers/adminSlice";
import { setUser } from "./Service/Reducers/userSlice";
import ChangeRole from "./Components/ChangeRole/ChangeRole";
import { setMember, clearMember } from "./Service/Reducers/memberSlice";
import { setToken } from "./Service/Reducers/acctknSlice";
import ConfirmForgotPassword from "./Components/Login/ChangePassword";
import AuthVerify from "./Auth/auth-verify";

const App = () => {
  const [auth, setAuth] = useState(sessionStorage.getItem("accessToken"));
  const dispatch = useDispatch();

  let isUserAdmin = (arr) => {
    arr.map((i) => {
      if (i == "admin") {
        dispatch(setAdmin());
      }
    });
  };
  let isUserMember = (arr) => {
    arr.map((i) => {
      if (i == "member") {
        dispatch(setMember());
      }
    });
  };

  useEffect(() => {
    let idToken = auth ? jwtDecode(sessionStorage.idToken.toString()) : false;
    let accessToken = auth
      ? jwtDecode(sessionStorage.accessToken.toString())
      : false;
    dispatch(setToken(accessToken));
    if (idToken["cognito:groups"]) {
      isUserAdmin(idToken["cognito:groups"]);
      isUserMember(idToken["cognito:groups"]);
    } else {
      dispatch(clearAdmin());
      dispatch(clearMember());
    }
    if (idToken["cognito:username"]) {
      dispatch(setUser(idToken["cognito:username"]));
    }
  }, [auth]);

  const logOut = () => {
    sessionStorage.clear();
    setAuth(sessionStorage.getItem("accessToken"));
    <Navigate to="/login" />;
  };

  return (
    <BrowserRouter>
      {auth ? <Navbar setAuth={setAuth} /> : <></>}
      <Routes>
        <Route
          path="/"
          element={
            auth ? (
              <Navigate replace to="/accounts" />
            ) : (
              <Navigate replace to="/login" />
            )
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/changepassword" element={<ConfirmForgotPassword />} />
        <Route path="/confirm" element={<ConfirmUserPage />} />
        <Route
          path="/accounts"
          element={auth ? <Accounts /> : <Navigate replace to="/login" />}
        />
        <Route
          path="/changerole"
          element={auth ? <ChangeRole /> : <Navigate replace to="/login" />}
        />
        <Route
          path="/activity"
          element={auth ? <Activity /> : <Navigate replace to="/login" />}
        />
        <Route
          path="/add-accounts"
          element={auth ? <AddAccounts /> : <Navigate replace to="/login" />}
        />
      </Routes>
      <AuthVerify logOut={logOut} />
    </BrowserRouter>
  );
};

export default App;
